module.exports = __webpack_public_path__ + "img/Ja-T600.4b74689d.gif";